module.exports = __webpack_public_path__ + "img/white.ee1119d2.png";